import { createElement } from '../../../core/dom/helpers.js';

/** @type {import('../../../contracts/filters.js').FilterDriver} */
export const checkboxFilterDriver = {
  type: 'checkbox',
  mount(container, ctx) {
    const { def, onChange } = ctx;

    const wrapper = createElement('div', { class: 'checkbox-filter' });
    const input = /** @type {HTMLInputElement} */ (createElement('input', {
      type: 'checkbox',
      id: `filter-${def.key}`,
      name: def.key,
    }));

    if (ctx.value === 'true') {
      input.checked = true;
    }

    input.addEventListener('change', () => onChange(input.checked ? 'true' : ''));
    wrapper.appendChild(input);
    container.appendChild(wrapper);

    return {
      setValue(value) {
        input.checked = value === 'true';
      },
      getValue() {
        return input.checked ? 'true' : '';
      },
      destroy() {
        wrapper.remove();
      },
    };
  },
};
